<template>
    <div class="card-container" :class="`card-container--${size}`">
        <slot></slot>
    </div>
</template>

<script setup lang="ts">
import { CardSize } from 'types/components/common/Card.type';

interface Props {
    size?: CardSize;
}

withDefaults(defineProps<Props>(), {
    size: CardSize.LARGE,
});
</script>

<style lang="scss" scoped>
.card-container {
    background: var(--colors-common-background-default);
    box-shadow: var(--elevation-1);

    & + & {
        margin: var(--spacing-4) 0 0;
    }

    &--large {
        border-radius: var(--spacing-1);
        padding: var(--spacing-4);
    }

    &--medium {
        border-radius: var(--spacing-0);
        padding: var(--spacing-3);
    }
}
</style>
